/**
 * CareTile - Tile design for Care section
 *
 * Uses BaseTile with full-bleed background image design.
 * Focus: Wellness and personal development benefits
 */
import React from 'react';
import BaseTile from './BaseTile';

function CareTile({
  resource,
  sectionColor,
  onClick,
  adminMode,
  onRemove,
  onMoveLeft,
  onMoveRight,
  isFirst,
  isLast,
}) {
  return (
    <BaseTile
      resource={resource}
      sectionColor={sectionColor}
      onClick={onClick}
      adminMode={adminMode}
      onRemove={onRemove}
      onMoveLeft={onMoveLeft}
      onMoveRight={onMoveRight}
      isFirst={isFirst}
      isLast={isLast}
    />
  );
}

export default CareTile;
